import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { SiteFilter, StatusFilter, TimeRangeFilter, WirelessControllerFilter } from '../../filters';
import AccessPointListPanel from '../../panels/ipm-list-panels/AccessPointListPanel';

export const pageId = 'access-points';

export default function AccessPointsPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Access Points`}>
                <FilterContainer>
                    <TimeRangeFilter required />
                    <WirelessControllerFilter />
                    <SiteFilter />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <AccessPointListPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
